export const moduleLabCases = {
  namespaced: true,
  state: {
    inlabpage : false,
  },
  getters: {
    labpagestatus(state){
       return state.inlabpage;
    }
  },
  mutations: {
    Setlabpagestatus(state,value){
        state.inlabpage = value;
    }
  },
  actions:{

  },
};